import { ApiError } from './client';

/** What a 402 `plan_feature_required` (PlanFeatureGuard) says is missing. */
export interface PlanFeatureRequired {
  /** The plan feature key (`outbound_webhooks`, `custom_roles`, …); null if the body has none. */
  feature: string | null;
  /** The team's current plan code (`free`, …); null if the body has none. */
  planCode: string | null;
}

/**
 * The missing plan feature when `err` is the API's 402 `plan_feature_required`
 * (a team plan without that capability), else null. Screens use it to draw a
 * locked "Available on the Team plan" state instead of an error, and the
 * global mutation handler turns it into an upgrade toast.
 */
export function planFeatureRequired(err: unknown): PlanFeatureRequired | null {
  if (!(err instanceof ApiError) || err.status !== 402) return null;
  if (err.code !== 'plan_feature_required') return null;
  const body = err.body.error as { feature?: unknown; planCode?: unknown };
  return {
    feature: typeof body.feature === 'string' ? body.feature : null,
    planCode: typeof body.planCode === 'string' ? body.planCode : null,
  };
}

/** Any "your plan doesn't include this" 402 — team plan features or the Personal tier. */
export function isPlanGateError(err: unknown): boolean {
  return (
    err instanceof ApiError &&
    err.status === 402 &&
    (err.code === 'plan_feature_required' || err.code === 'upgrade_required')
  );
}
